// src/icons/NodeAdd.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function NodeAdd({
  strokeWidth = "1",
  strokeLinecap = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6 3.25V8.75M3.25 6H8.75M11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap
        }
      )
    }
  );
}

export {
  NodeAdd
};
